const { UtilDevice, Bridge } = require('@iskytrip/sdk')

const Compontents = {
	get Toast() {
		if (UtilDevice.isApp()) {
			return Bridge.appToast
		} else {
			const module = require('./Toast')
			return module && module.__esModule ? module.default : module
		}
	},
	get Flex() {
		const module = require('./Flex')
		return module && module.__esModule ? module.default : module
	},
	get Alert() {
		const module = require('./Alert')
		return module && module.__esModule ? module.default : module
	},
	get Modal() {
		const module = require('./Modal')
		return module && module.__esModule ? module.default : module
	},
	get Tabs() {
		const module = require('./Tabs')
		return module && module.__esModule ? module.default : module
	},
	get Header() {
		const module = require('./Header')
		return module && module.__esModule ? module.default : module
	},
	get Button() {
		const module = require('./Button')
		return module && module.__esModule ? module.default : module
	},
	get Inputer() {
		const module = require('./Inputer')
		return module && module.__esModule ? module.default : module
	},
	get Loading() {
		const module = require('./Loading')
		return module && module.__esModule ? module.default : module
	},
	get QrCode() {
		const module = require('./QrCode')
		return module && module.__esModule ? module.default : module
	},
	get Stepper() {
		const module = require('./Stepper')
		return module && module.__esModule ? module.default : module
	},
	get Iconfont() {
		const module = require('./Iconfont')
		return module && module.__esModule ? module.default : module
	},
	get DateTime() {
		const module = require('./DateTime')
		return module && module.__esModule ? module.default : module
	},
	get TextInput() {
		const module = require('./TextInput')
		return module && module.__esModule ? module.default : module
	},
	get SideSwiper() {
		const module = require('./SideSwiper')
		return module && module.__esModule ? module.default : module
	},
	get CitySelect() {
		const module = require('./Biz/CitySelect')
		return module && module.__esModule ? module.default : module
	},
	get LoadingPage() {
		const module = require('./LoadingPage')
		return module && module.__esModule ? module.default : module
	},
	get IconCodeEmum() {
		const module = require('./Iconfont/iconCodeEmum')
		return module && module.__esModule ? module.default : module
	},
	get PullUpViewPage() {
		const module = require('./PullUpViewPage')
		return module && module.__esModule ? module.default : module
	},
	get VehicleKeyboard() {
		const module = require('./Biz/VehicleKeyboard')
		return module && module.__esModule ? module.default : module
	},
	get GLPayBar() {
		const module = require('./GLPayBar')
		return module && module.__esModule ? module.default : module
	},
	get GLOrderInfo() {
		const module = require('./GLOrderInfo')
		return module && module.__esModule ? module.default : module
	},
	get GLVideoItem() {
		const module = require('./GLVideoItem')
		return module && module.__esModule ? module.default : module
	},
	get GLModalCoupons() {
		const module = require('./GLModalCoupons')
		return module && module.__esModule ? module.default : module
	},
	get GLProductRules() {
		const module = require('./GLProductRules')
		return module && module.__esModule ? module.default : module
	},
	get GLNaviCarousel() {
		const module = require('./GLNaviCarousel')
		return module && module.__esModule ? module.default : module
	},
	get GLCouponItem() {
		const module = require('./GLDiscounts/couponItem')
		return module && module.__esModule ? module.default : module
	},
	get GLEquityItem() {
		const module = require('./GLDiscounts/equityItem')
		return module && module.__esModule ? module.default : module
	},
	get CouponModal() {
		const module = require('./CouponModal')
		return module && module.__esModule ? module.default : module
	},
	get GLOrderCoupon() {
		const module = require('./GLOrderCoupon')
		return module && module.__esModule ? module.default : module
	},
	get GLOrderCouponSuccess() {
		const module = require('./GLOrderCouponSuccess')
		return module && module.__esModule ? module.default : module
	},
	get GLProductSeckill() {
		const module = require('./GLProductSeckill')
		return module && module.__esModule ? module.default : module
	},
	get ActivityModal() {
		const module = require('./ActivityModal')
		return module && module.__esModule ? module.default : module
	},
	get ServiceModal() {
		const module = require('./ServiceModal')
		return module && module.__esModule ? module.default : module
	},
	get RefundModal() {
		const module = require('./RefundModal')
		return module && module.__esModule ? module.default : module
	},
	get GLNaviCarouselNew() {
		const module = require('./GLNaviCarouselNew')
		return module && module.__esModule ? module.default : module
	},
	get GLProductIntroduction() {
		const module = require('./GLProductIntroduction')
		return module && module.__esModule ? module.default : module
	},
	get GLProductUseProcess() {
		const module = require('./GLProductUseProcess')
		return module && module.__esModule ? module.default : module
	},
	get GLPayBarDetail() {
		const module = require('./GLPayBarDetail')
		return module && module.__esModule ? module.default : module
	},
	get GLModalRules() {
		const module = require('./GLModalRules')
		return module && module.__esModule ? module.default : module
	},
	get GLModalDateTime() {
		const module = require('./GLModalDateTime')
		return module && module.__esModule ? module.default : module
	},
	get GLOrderIntegralView() {
		const module = require('./GLOrderIntegralView')
		return module && module.__esModule ? module.default : module
	},
	get FloatingPanel() {
		const module = require('./FloatingPanel')
		return module && module.__esModule ? module.default : module
	},
	get FloatingPanelView() {
		const module = require('./FloatingPanelView')
		return module && module.__esModule ? module.default : module
	},
	get Barcode() {
		const module = require('./Barcode')
		return module && module.__esModule ? module.default : module
	},
	get MarkDown() {
		const module = require('./MarkDown')
		return module && module.__esModule ? module.default : module
	},
}

module.exports = Compontents
